<div class="tab-section">
  <div class="dropdown-select">
    <span class="division-label">Division:</span>
    <p-dropdown
      [options]="dropDownData"
      [(ngModel)]="selectedDivision"
      optionLabel="label"
      optionValue="value"
      [autoDisplayFirst]="true"
      (onChange)="onDivisionChange()"
    >
    </p-dropdown>
  </div>

  <div class="mt-10">
    <p-table  styleClass="p-datatable-gridlines"
      *ngIf="removedData.length > 0"
      [value]="removedData"
      [scrollable]="true"
      scrollHeight="400px"
      id="StyleTable"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Division</th>
          <th>Section</th>
          <th>TLR#</th>
          <th>TLR Status</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.division }}</td>
          <td>{{ row.section }}</td>
          <td [ngClass]="row.cssClass">{{ row.tlr }}</td>
          <td [ngClass]="row.cssClass">{{ row.status }}</td>
          <td><a (click)="details(row)" class="link-underline">Details</a></td>
        </tr>
      </ng-template>
    </p-table>
    <p class="MessageTitle" *ngIf="removedData.length == 0">
      There are no TLR's that have been AIR (Removed)
    </p>
  </div>
</div>
